import $ from 'jquery';
import Popin from './generic/popin';
import Counter from './generic/counter';
import SessionStoragePop from './generic/SessionStoragePop';
import MethodUtils from './generic/methodUtils';
import {MARKET} from 'Utils/market.constants';

// constants for Gsa search
const ALERTING_TEXT = {
    SEE_DETAIL: 'Voir le détail',
    SEE_ALERTS: 'Voir les notifications'
}

const ALERTING_DEFAULT_VALUES = {
    URL_SIGNATURE: "/com/icd-web/alerting/fil-alertes.html",
    URL_SERVICE : "/icd/alerting/data/nouvellesalertes.json",
    SESSION_KEY: "alerting_counter",
    MOBILE_BREAKPOINT : 768,
    CURRENT_APP: "alerting",
    PRIORITY_MOBILE: 2
}

const ALERTING_SELECTOR = {
    ID_ZONE : "#js-container-alerting-zone",
    ID_COUNTER: '#js-counter-alerting',
    ID_COUNTER_MOBILE: '#js-counter-alerting-mobile'
}

export default class AlertingApp {

    constructor() {
        var _self = this;

        _self.dataResponse = {};

        // init default values
        _self.urlService = ALERTING_DEFAULT_VALUES.URL_SERVICE;
        _self.sessionKey = ALERTING_DEFAULT_VALUES.SESSION_KEY;
        _self.needToDisplayPopinByDefault = false;
        _self.currentApp = ALERTING_DEFAULT_VALUES.CURRENT_APP;

        // init from conf
        _self.initPropertiesFromConf();

        // init Session storage popin Obj
        _self.sessionStoragePop = new SessionStoragePop(_self.sessionKey, _self.intervalTime);

        // init Util Method
        _self.util = new MethodUtils();

        // Init Popin & counter
        _self.popin = new Popin(ALERTING_SELECTOR.ID_ZONE, _self.currentApp, _self.priorityMobile, false);

        // Same counter Mobile / Desktop
        _self.counter = new Counter(ALERTING_SELECTOR.ID_COUNTER);
        if(MARKET.CODE === 1) {
            _self.counterMobile = new Counter(ALERTING_SELECTOR.ID_COUNTER_MOBILE);
        }

        _self.isInRefreshingMode = true;

        // init alerting Interval
        _self.refreshIntervalId = _self.launchTimer(_self.sessionStoragePop.getJsonObjectFromSession(), function () {
            if (_self.isInRefreshingMode)
                _self.updateNotification();
        }, _self.intervalTime);

        _self.updateNotification();

        // Event when first element closed
        window.EventBusCMS.addEventListener('popinGenericEventOnClose', event => {
            if (event.detail.currentApp === _self.currentApp) {
                _self.updateSessionStorageOnClick();
            }
        });
    }

    initPropertiesFromConf() {
        this.urlDetail = window.cmsGlobals.alertingConfig.urlAlertDetail;
        this.urlGlobal = window.cmsGlobals.alertingConfig.urlAlerts;
        this.intervalTime = window.cmsGlobals.alertingConfig.alertingIntervalTime;

        if (window.cmsGlobals.alertingConfig.urlAlertingSignature) {
            this.urlAlertingSignature = window.cmsGlobals.alertingConfig.urlAlertingSignature;
        } else {
            this.urlAlertingSignature = ALERTING_DEFAULT_VALUES.URL_SIGNATURE;
        }

        // Init default priority popin on mobile
        this.priorityMobile = ALERTING_DEFAULT_VALUES.PRIORITY_MOBILE;
    }

    launchTimer(data, appliFunction, time) {
        if (data !== null) {
            setTimeout(appliFunction, new Date(data.expirationDate).getTime() - new Date().getTime());
        }
        return this.util.updateApplicationNotificationEvery(appliFunction, 60000 * time);
    }

    /**
     * Update Session Storage with popin data
     */
    updateSessionStorage() {
        var _self = this;

        if (_self.dataResponse) {
            _self.dataResponse.closed = false;
            _self.sessionStoragePop.updateSessionStorage(_self.dataResponse);
        }
    }

    updateNotification() {
        var _self = this;

        // If we are on current page alerting, we only display counter
        // else we display counter and popin
        if (_self.urlAlertingSignature.indexOf(window.location.pathname) !== -1) {
            _self.needToDisplayPopin = false;
            _self.sessionStoragePop.resetCounterInSession();
            _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();

            _self.updateDOM();
        } else {
            _self.needToDisplayPopin = true;
            _self.dataResponse = _self.sessionStoragePop.getJsonObjectFromSession();
            if (_self.dataResponse == null) {
                _self.callAlertingService();
            } else {
                if ((new Date(_self.dataResponse.expirationDate).getTime() - new Date().getTime()) / 60000 > 0) {
                    _self.updateDOM();
                } else {
                    _self.callAlertingService();
                }
            }

        }
    }

    /**
     * Call the service exposed by Alerting in order to recover the notification numbers
     */
    callAlertingService() {
        var _self = this;

        $.ajax({
            url: _self.urlService,
            method: "GET",
            swmIntercept: false,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            beforeSend: function(request) {
                request.setRequestHeader("x-no-session-postpone", "true");
            },
            success: function (response) {
                if (response && response.commun.statut.toLowerCase() === "ok") {
                    _self.dataResponse = {};
                    _self.dataResponse.counterVal = response.donnees.compteur,
                    _self.dataResponse.dateMessage = response.donnees.message.date;
                    _self.dataResponse.message = response.donnees.message.libelleCta;
                    _self.dataResponse.idAlerte = response.donnees.message.idAlerte;

                    if (_self.dataResponse.counterVal !== null &&
                        _self.dataResponse.counterVal !== undefined) {

                        if (_self.dataResponse.counterVal !== "0" && _self.dataResponse.counterVal !== 0) {
                            var data = _self.sessionStoragePop.getJsonObjectFromSession();

                            // If data & popin has been closed, popin need to be displayed only if new notification come
                            if (data !== null && data.closed) {
                                if (_self.dataResponse.counterVal !== data.counterVal) {
                                    _self.needToDisplayPopin = true;
                                }
                            // if we have response but not initial data in session, display the popin
                            } else if (data == null) {
                                _self.needToDisplayPopin = true;
                            }
                        }

                        _self.updateSessionStorage();
                        _self.updateDOM();
                    }
                } else {
                    _self.isInRefreshingMode = false;
                    window.sessionStorage.removeItem(_self.sessionKey);
                }
            },
            error: function () {
                _self.isInRefreshingMode = false;
                window.sessionStorage.removeItem(_self.sessionKey);
                console.error("Erreur réseau");
            }
        });
    }


    /**
     * Update the html for both counter and infobulle
     */
    updateDOM() {
        var _self = this;

        // Update Counter
        _self.counter.updateHtml(_self.util.getNotificationCounterToShow(_self.dataResponse.counterVal));
        if(MARKET.CODE === 1) {
            _self.counterMobile.updateHtml(_self.util.getNotificationCounterToShow(_self.dataResponse.counterVal));
        }

        // Update popin if message is present
        if (_self.dataResponse.message !== null && _self.needToDisplayPopin) {
            this.updatePopinHtml();
        }
    }

    /**
     * Update HTML Popin
     */
    updatePopinHtml() {
        var _self = this;
        var popinPreviouslyOpen = _self.popin.isOpen;

        _self.popin.hide();
        _self.preparePopinData();

        // on mobile, only activate
        if ($(window).width() < ALERTING_DEFAULT_VALUES.MOBILE_BREAKPOINT) {
            if (popinPreviouslyOpen) {
                _self.popin.show();
            } else {
                _self.popin.activate();
            }
        } else {
            _self.popin.show();
        }
    }

    /**
     * Update Session on click
     */
    updateSessionStorageOnClick() {
        var _self = this;
        var info = _self.sessionStoragePop.getJsonObjectFromSession();
        var remainingTime = (new Date(info.expirationDate).getTime() - new Date().getTime()) / 60000;

        // put new interval time
        _self.sessionStoragePop.setIntervalTime(remainingTime);

        // update counter info in session on click
        _self.sessionStoragePop.updateCounterAlone(info.counterVal, true);
    }

    /**
     * Update notification infobulle
     */
    preparePopinData() {
        var _self = this;
        var data = {};

        if (_self.dataResponse.dateMessage !== null) {
            data.headLine = _self.dataResponse.dateMessage;
        }

        if (_self.dataResponse.message !== null) {
            data.description = _self.dataResponse.message;
        }

        if (_self.dataResponse.counterVal == "1" || _self.dataResponse.counterVal == 1) {
            var href = _self.urlDetail + _self.dataResponse.idAlerte;
            data.href = href;
            data.textLink = ALERTING_TEXT.SEE_DETAIL;
        } else {
            var href = _self.urlGlobal;
            data.href = href;
            data.textLink = ALERTING_TEXT.SEE_ALERTS;
        }

        _self.popin.updatePopinData(data);
    }
}


// WEBPACK FOOTER //
// ./src/js/cms/commons/loginbox/popin/alerting.js